const stateRateAction = {
    SAVE : 'save',

    DISCARD : 'discard',

    BACKUP : 'backup'

};

angular.module('gw-um-j2js')
    .constant('stateRateAction', stateRateAction);